(() => {
  if (window.fritzKlaviyoScrollFix) return;
  window.fritzKlaviyoScrollFix = true;
  const lock = 'klaviyo-prevent-body-scrolling';
  const selector = '[data-testid="POPUP"], form.klaviyo-form';
  let timer;
  function visible(el) {
    const box = el.getBoundingClientRect();
    if (box.width < 80 || box.height < 80) return false;
    for (let p = el; p && p !== document.body; p = p.parentElement) {
      const cs = getComputedStyle(p);
      if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) < .1) return false;
    }
    return true;
  }
  function recover() {
    // Embedded newsletter forms must not keep a dismissed popup's lock alive.
    const forms = Array.from(document.querySelectorAll(selector)).filter(el => {
      if (el.matches('[data-testid="POPUP"]')) return true;
      for (let p = el; p && p !== document.body; p = p.parentElement) {
        if (p.matches('[data-testid="POPUP"]') || getComputedStyle(p).position === 'fixed') return true;
      }
      return false;
    });
    if (forms.some(visible)) {
      forms.forEach(el => el.classList.remove('fritz-kl-dismissed'));
      return;
    }
    document.body.classList.remove(lock);
    // Neutralize only known hidden popup containers, never embedded forms.
    forms.forEach(el => {
      // Older Klaviyo popups put the invisible click layer around the form.
      let container = el;
      for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
        if (p.matches('[data-testid="POPUP"], div[class*="kl-private-reset-css"]')) container = p;
      }
      if (getComputedStyle(container).display !== 'none') container.classList.add('fritz-kl-dismissed');
    });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(recover, 900); }
  window.addEventListener('klaviyoForms', event => {
    const type = event.detail?.type;
    if (type === 'open' || type === 'embedOpen') {
      clearTimeout(timer);
      document.querySelectorAll('.fritz-kl-dismissed').forEach(el => el.classList.remove('fritz-kl-dismissed'));
    } else if (type === 'close' || type === 'redirectedToUrl') schedule();
  });
  new MutationObserver(() => { if (document.body.classList.contains(lock)) schedule(); }).observe(document.body, {attributes:true,attributeFilter:['class']});
  schedule();
})();
